<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">mdi-file</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div>
            <v-container>
              <v-row>
                <v-col>
                  <div class="information-block">
                    <div class="row">
                      <div class="col no-padding-bottom">
                        <div class="information-detail">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 10em;"
                          >
                            <div>{{ $t("messages.general.identity") }}</div>
                          </div>
                          <div class="col no-margin-padding">
                            <div>{{ studentCode }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col no-padding-bottom">
                        <div class="information-detail">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 10em;"
                          >
                            <div>{{ $t("messages.general.fullname") }}</div>
                          </div>
                          <div class="col no-margin-padding">
                            <div>{{ displayName }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col no-padding-bottom">
                        <div class="information-detail">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 10em;"
                          >
                            <div>{{ $t("messages.general.academicYear") }}</div>
                          </div>
                          <div class="col no-margin-padding">
                            <div>{{ appInfo.data.CURRENT_ACADYEAR }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col no-padding-bottom">
                        <div class="information-detail">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 10em;"
                          >
                            <div>{{ $t("messages.general.semester") }}</div>
                          </div>
                          <div class="col no-margin-padding">
                            <div>{{ appInfo.data.CURRENT_SEMESTER }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <p>
                        <b>{{
                          $t("messages.reqRegister.remarkClassStatusH")
                        }}</b
                        ><br />
                        {{ $t("messages.reqRegister.remarkClassStatusO")
                        }}<br />
                        {{ $t("messages.reqRegister.remarkClassStatusC")
                        }}<br />
                        {{ $t("messages.reqRegister.remarkClassStatusCOP") }}
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>

          <v-expansion-panels
            :readonly="readonly"
            :multiple="multiple"
            accordion
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("messages.general.classByPlan") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="table-responsive">
                  <table class="table table-striped" id="table-epp1">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t("messages.general.seqOrder") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classId") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.className") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.credit") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.grade") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in classListByPlan" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center">{{ item.COURSECODE }}</td>
                        <td v-html="item.COURSENAME">{{ item.COURSENAME }}</td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.COURSEUNIT }}
                        </td>
                        <td class="text-center">{{ item.GRADEMODE }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("messages.general.classReserved") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="table-responsive">
                  <table class="table table-striped" id="table-epp2">
                    <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">
                          {{ $t("messages.general.select") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.seqOrder") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classId") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.className") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.section") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.credit") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.grade") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classTime") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classStatus") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in classReservedList"
                        :key="index"
                        :class="epp2Selected == index ? 'eep2Sel' : ''"
                      >
                        <td class="text-center">
                          <v-icon @click="openClassReserved(index)"
                            >search</v-icon
                          >
                        </td>
                        <td class="text-center">
                          <v-btn
                            x-small
                            color="rgba(11, 187, 236, 0.9)"
                            @click="handleClickSelectedEpp2(index)"
                            :disabled="item.ISSHOW_SELECTBUTTON == 'N'"
                            >select</v-btn
                          >
                        </td>
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center">{{ item.COURSECODE }}</td>
                        <td>{{ item.COURSENAME }}</td>
                        <td class="text-center">{{ item.SECTION_TEXT }}</td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.COURSEUNIT }}
                        </td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.GRADEMODE_TEXT }}
                        </td>
                        <td v-html="item.CLASSTIME" style="white-space: nowrap">
                          {{ item.CLASSTIME }}
                        </td>
                        <td class="text-center">{{ item.CLASSSTATUS }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels v-model="expPanels" readonly>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("messages.general.selectedClass") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="table-responsive">
                  <table class="table table-striped" id="table-1">
                    <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                color="white"
                                size="32"
                                @click="openAddSelected(1)"
                                >add_circle</v-icon
                              >
                            </template>
                            <span>{{
                              $t("messages.general.addClassTooltip")
                            }}</span>
                          </v-tooltip>
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.seqOrder") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classCode") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.credit") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.grade") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classTime") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.section") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classStatus") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.confirm") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.reason") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in classSelectedList"
                        :key="index"
                        :class="epp3Selected == index ? 'eep3Sel' : ''"
                      >
                        <td class="text-center">
                          <v-btn text icon @click="openSelected(index)">
                            <v-icon>search</v-icon>
                          </v-btn>
                        </td>
                        <td class="text-center">
                          <v-btn
                            icon
                            @click="handleDelete(item)"
                            v-if="item.ISSHOW_DELETEBUTTON == 'Y'"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </td>
                        <td class="text-center">{{ index + 1 }}</td>
                        <td style="white-space: nowrap">
                          {{ item.COURSENAME }}
                        </td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.COURSEUNIT }}
                        </td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.GRADEMODE_TEXT }}
                        </td>
                        <td
                          v-html="item.CLASSTIME"
                          class="text-center"
                          style="white-space: nowrap"
                        >
                          {{ item.CLASSTIME }}
                        </td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.SECTION_TEXT }}
                          <v-tooltip
                            v-if="item.ISSHOW_CHANGESELECTBUTTON == 'Y'"
                            bottom
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                fab
                                small
                                v-on="on"
                                color="rgba(11, 187, 236, 0.9)"
                                @click="openDialogChangeSection(index)"
                              >
                                <v-icon color="black">autorenew</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t("messages.general.changeClsTooltip")
                            }}</span>
                          </v-tooltip>
                        </td>
                        <td class="text-center">{{ item.CLASSSTATUS }}</td>
                        <td class="text-center">{{ item.CONFIRM_FLAG }}</td>
                        <td class="text-center" style="white-space: nowrap">
                          {{ item.REASON }}
                          <v-btn
                            fab
                            small
                            v-on="on"
                            color="rgba(11, 187, 236, 0.9)"
                            @click="openDialogEdit(item)"
                            v-if="item.ISSHOW_EDITBUTTON == 'Y'"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <br />
          <br />
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.totalClass") }}</div>
                  </div>
                  <div class="col no-margin-padding text-right">
                    <div style="padding-right: 15px;">
                      {{ footerTotal.TOTAL_CLASS }}
                    </div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ $t("messages.general.subject") }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.totalCredit") }}</div>
                  </div>
                  <div class="col no-margin-padding text-right">
                    <div style="padding-right: 15px;">
                      {{ footerTotal.TOTAL_CREDIT }}
                    </div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ $t("messages.general.credit") }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.totalClsConfirm") }}</div>
                  </div>
                  <div class="col no-margin-padding text-right">
                    <div style="padding-right: 15px;">
                      {{ footerTotal.TOTAL_CLASS_CONFIRM }}
                    </div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ $t("messages.general.subject") }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.totalCreditConfirm") }}</div>
                  </div>
                  <div class="col no-margin-padding text-right">
                    <div style="padding-right: 15px;">
                      {{ footerTotal.TOTAL_CREDIT_CONFIRM }}
                    </div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ $t("messages.general.credit") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-container>
            <v-row>
              <v-col>
                <button
                  class="btn btn-lg btn-temp"
                  @click="openDialogDetailAll()"
                >
                  {{ $t("messages.general.showDetailSelectedAll") }}
                </button>
              </v-col>
              <v-col style="text-align: right">
                <button class="btn btn-primary btn-lg" @click="handleConfirm()">
                  {{ $t("messages.reqRegister.confirmReqRegisterSelected") }}
                </button>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-if="isLateReq == true">
            <div v-html="preEnrollWithInstructorMsg">
              {{ preEnrollWithInstructorMsg }}
            </div>
            <div class="table-responsive">
              <table class="table table-striped" id="table-1">
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("messages.general.seqOrder") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.instructor") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.classCode") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.section") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in preEnrollWithInstructor"
                    :key="index"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td
                      v-html="item.INSTRUCTORNAME"
                      style="white-space: nowrap"
                    >
                      {{ item.INSTRUCTORNAME }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ item.COURSENAME }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.SECTION_TEXT }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-container>

          <div
            v-if="isShowCaution"
            class="text-left"
            style="border: darkred 3px solid; border-radius: 5px;"
          >
            <v-sheet
              style="padding: 15px; color: #ffebee;"
              :height="height"
              color="red"
            >
              <v-row>
                <v-col cols="1" align-self="center" class="text-center">
                  <v-icon large>fa-exclamation-circle</v-icon>
                </v-col>
                <v-col>
                  <strong>
                    {{ $t("messages.reqRegister.showCaution") }}
                  </strong>
                </v-col>
              </v-row>
            </v-sheet>
          </div>
          <br />
          <div
            v-if="isShowCautionText"
            class="text-left"
            style="border: darkred 3px solid; border-radius: 5px;"
          >
            <v-sheet
              style="padding: 15px; color: #ffebee;"
              :height="height"
              color="red"
            >
              <v-row>
                <v-col cols="1" align-self="center" class="text-center">
                  <v-icon large>fa-exclamation-circle</v-icon>
                </v-col>
                <v-col>
                  <strong v-html="showCautionText">
                    {{ showCautionText }}
                  </strong>
                </v-col>
              </v-row>
            </v-sheet>
          </div>

          <v-dialog
            v-model="dialogSearchClass"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearchClass = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classId") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgAddSelCourseCode"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.className") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgAddSelCourseName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onDlgSearchClassSelFacultyChanged"
                            :selectedVal="dlgSearchClassSelFaculty"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onDlgSearchClassSelDepartmentChanged"
                            :facultyid="dlgSearchClassSelFaculty"
                            :selectedVal="dlgSearchClassSelDepartment"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classGroup") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <ClassType
                            :onChanged="onDlgSearchClassSelClsTypeChanged"
                            :selectedVal="dlgSearchClassSelClsType"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.educationLvl")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onDlgSearchClassSelLvlChanged"
                            :selectedVal="dlgSearchClassSelLvl"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-temp btn-lg"
                          @click="handleSearchCls()"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="handleClearSearchCls()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <v-switch
                          v-model="structure"
                          :label="this.$t('messages.general.onlyClsInCourse')"
                        ></v-switch>
                      </div>
                    </div>
                  </div>
                  <div class="form-row text-center">
                    <div class="col no-padding-bottom">
                      <label style="color: red"
                        >{{ $t("messages.general.remarkClickSearch1") }}
                        <v-icon>search</v-icon>
                        {{ $t("messages.general.remarkClickSearch2") }}</label
                      >
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    responsive
                    small
                    caption-top
                    class="temp-table-responsive table temp-table-striped text-center"
                    :sort-by.sync="bTable.sortBy"
                    :sort-desc.sync="bTable.sortDesc"
                    :items="bTable.items"
                    :fields="bTable.fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTable.items.length"
                        v-model="currentPage"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTable.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPage > 1
                              ? (currentPage - 1) * perPage + 1
                              : currentPage
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPage * perPage > bTable.items.length
                              ? bTable.items.length
                              : currentPage * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTable.items.length).toLocaleString() }}
                      </div>
                      <div
                        v-if="bTable.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTable.items.length).toLocaleString() }}
                      </div>
                    </template>

                    <template v-slot:cell(action)="data">
                      <v-btn
                        text
                        icon
                        @click="openDetail(data.item, data.index)"
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:cell(COURSECODE)="data">
                      <a
                        @click="handleSelectClass(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.COURSECODE }}
                      </a>
                    </template>

                    <template v-slot:cell(CLASSTIME)="data">
                      <div v-html="data.item.CLASSTIME">
                        {{ data.item.CLASSTIME }}
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogSelected"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>description</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classDetail")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSelected = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.ACADYEAR }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.SEMESTER }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classId") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.COURSECODE }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.className") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.COURSENAME }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.credit") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.COURSEUNIT }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.faculty") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.FACULTYNAME }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.department") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.DEPARTMENTNAME }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classStatus") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classSelDetial.COURSESTATUS }}</div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <v-card>
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ $t("messages.general.section") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.classType") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.classTime") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.room") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.receiveAmount") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.registerAmount") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.remainAmount") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.requestAmount") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">
                            {{ classSelDetial.SECTION2 }}
                          </td>
                          <td
                            v-html="classSelDetial.CLASSTYPE"
                            class="text-center"
                          >
                            {{ classSelDetial.CLASSTYPE }}
                          </td>
                          <td
                            v-html="classSelDetial.CLASSTIME"
                            class="text-center"
                            style="white-space: nowrap"
                          >
                            {{ classSelDetial.CLASSTIME }}
                          </td>
                          <td
                            v-html="classSelDetial.CLASSROOM"
                            class="text-center"
                            style="white-space: nowrap"
                          ></td>
                          <td class="text-center">
                            {{ classSelDetial.TOTALSEAT }}
                          </td>
                          <td class="text-center">
                            {{ classSelDetial.TOTALSUMSEAT }}
                          </td>
                          <td class="text-center">
                            {{
                              classSelDetial.TOTALSEAT -
                                classSelDetial.TOTALSUMSEAT
                            }}
                          </td>
                          <td class="text-center">
                            {{ classSelDetial.ENROLLSEAT }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="9" style="padding: 0 !important">
                            <v-expansion-panels
                              accordion
                              style="height: 100%; border-radius: 0 !important"
                            >
                              <v-expansion-panel>
                                <v-expansion-panel-header>{{
                                  $t("messages.general.moreDetail")
                                }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div class="information-block">
                                    <div class="row">
                                      <div class="col no-padding-bottom">
                                        <div class="information-detail">
                                          <div
                                            class="col no-margin-padding"
                                            style="flex: 0 0 10em;"
                                          >
                                            <div>
                                              {{
                                                $t("messages.general.teachers")
                                              }}
                                            </div>
                                          </div>
                                          <div class="col no-margin-padding">
                                            <div>
                                              <span
                                                v-for="(item,
                                                index) in classSelDetial.arrInstructor"
                                                :key="index"
                                              >
                                                {{ item }}
                                                <br />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col no-padding-bottom">
                                        <div class="information-detail">
                                          <div
                                            class="col no-margin-padding"
                                            style="flex: 0 0 10em;"
                                          >
                                            <div>
                                              {{
                                                $t(
                                                  "messages.general.reserveFor"
                                                )
                                              }}
                                            </div>
                                          </div>
                                          <div class="col no-margin-padding">
                                            <v-icon
                                              @click="
                                                openSubDetail(classSelDetial)
                                              "
                                              >search</v-icon
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col no-padding-bottom">
                                        <div class="information-detail">
                                          <div
                                            class="col no-margin-padding"
                                            style="flex: 0 0 10em;"
                                          >
                                            <div>
                                              {{
                                                $t(
                                                  "messages.general.examMidTermDate"
                                                )
                                              }}
                                            </div>
                                          </div>
                                          <div class="col no-margin-padding">
                                            <div>
                                              {{
                                                classSelDetial.EXAM_MIDTERM_DATE
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col no-padding-bottom">
                                        <div class="information-detail">
                                          <div
                                            class="col no-margin-padding"
                                            style="flex: 0 0 10em;"
                                          >
                                            <div>
                                              {{
                                                $t(
                                                  "messages.general.examFinalTermDate"
                                                )
                                              }}
                                            </div>
                                          </div>
                                          <div class="col no-margin-padding">
                                            <div>
                                              {{
                                                classSelDetial.EXAM_FINAL_DATE
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col no-padding-bottom">
                                        <div class="information-detail">
                                          <div
                                            class="col no-margin-padding"
                                            style="flex: 0 0 10em;"
                                          >
                                            <div
                                              style="text-decoration: underline; color: blue"
                                            >
                                              {{
                                                $t("messages.general.remark")
                                              }}
                                            </div>
                                          </div>
                                          <div class="col no-margin-padding">
                                            {{
                                              classSelDetial.CLASSNOTE
                                                ? classSelDetial.CLASSNOTE
                                                : ""
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogDetailAll"
            scrollable
            persistent
            style="z-index: 600;"
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat>
                <v-toolbar-title>{{
                  $t("messages.reqRegister.inspectReqRegisterSelected")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogDetailAll = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <v-tabs>
                  <v-tab>{{ $t("messages.general.timeTable") }}</v-tab>
                  <v-tab>{{ $t("messages.general.examTimeTable") }}</v-tab>
                  <!-- <v-tab>{{ $t("messages.general.registerFee") }}</v-tab> -->
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text style="padding: 0">
                        <v-sheet height="57">
                          <v-toolbar flat color="white">
                            <v-btn outlined class="mr-4" @click="setToday">
                              {{ $t("messages.general.today") }}
                            </v-btn>
                            {{ prevDateRange }}
                            <v-btn fab text small @click="prev">
                              <v-icon small>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn fab text small @click="next">
                              <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                            {{ nextDateRange }}
                            <div class="flex-grow-1"></div>
                          </v-toolbar>
                        </v-sheet>
                        <v-sheet>
                          <v-calendar
                            ref="calendar"
                            v-model="focus"
                            type="week"
                            :color="color"
                            :events="events"
                            :event-color="eventColor"
                            :first-interval="intervals.first"
                            :interval-minutes="intervals.minutes"
                            :interval-count="intervals.count"
                            :interval-height="intervals.height"
                            :weekdays="weekDays"
                            :locale="locale"
                            :interval-format="intervalFormatter"
                            :weekday-format="weekdayFormatter"
                            :day-format="dayFormatter"
                            :event-name="getEventName"
                            @click:event="showEvent"
                          >
                          </v-calendar>
                        </v-sheet>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-card>
                          <div class="table-responsive">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th class="text-center">
                                    {{ $t("messages.general.seqOrder") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.classId") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.className") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.credit") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.examMidTermDate") }}
                                  </th>
                                  <th class="text-center">
                                    {{
                                      $t("messages.general.examFinalTermDate")
                                    }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in examData"
                                  :key="index"
                                >
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td class="text-center">
                                    {{ item.COURSECODE }}
                                  </td>
                                  <td>{{ item.COURSENAME }}</td>
                                  <td class="text-center">
                                    {{ item.COURSEUNIT }}
                                  </td>
                                  <td class="text-center">
                                    {{ item.EXAM_MIDTERM_DATE }}
                                  </td>
                                  <td class="text-center">
                                    {{ item.EXAM_FINAL_DATE }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <!-- <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-card>
                          <div class="table-responsive">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th class="text-center">
                                    {{ $t("messages.general.seqOrder") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.feeList") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.registationFee") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.overdueAmout") }}
                                  </th>
                                  <th class="text-center">
                                    {{ $t("messages.general.receiveCashBack") }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in financeData"
                                  :key="index"
                                >
                                  <td class="text-center">index+1</td>
                                  <td>
                                    {{ item.FEEIDNAME }}
                                  </td>
                                  <td class="text-right">
                                    {{ numberFormat(item.AMOUNT) }}
                                  </td>
                                  <td class="text-right">
                                    {{ numberFormat(item.BALANCE) }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      numberFormat(item.AMOUNT - item.BALANCE)
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <td class="text-center"></td>
                                <td class="text-right">
                                  {{ $t("messages.general.total") }}
                                </td>
                                <td class="text-right"></td>
                                <td class="text-right">
                                  {{ numberFormat(financeFooterData.total) }}
                                </td>
                                <td class="text-right">
                                  {{
                                    numberFormat(financeFooterData.totalBack)
                                  }}
                                </td>
                              </tfoot>
                            </table>
                          </div>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item> -->
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogAddSelected"
            hide-overlay
            scrollable
            max-width="1024px"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>edit</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.addSelectedClass")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogAddSelected = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classId") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div class="form-row">
                            <div
                              class="col no-margin-padding"
                              style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                            >
                              <div class="form-group" style="margin-bottom: 0;">
                                <div class="form-inline">
                                  <input
                                    type="text"
                                    class="form-control col mr-2"
                                    style="margin-right: 0px !important"
                                    v-model="dlgAddSelected.courseCode"
                                  />
                                  <button
                                    type="button"
                                    class="btn btn-temp btn-lg"
                                    @click="handleOpenSearchCls()"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col no-margin-padding"
                              style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                            >
                              <div class="form-group" style="margin-bottom: 0;">
                                <div class="form-inline">
                                  <input
                                    type="text"
                                    class="form-control col mr-2"
                                    style="margin-right: 0px !important"
                                    disabled
                                    v-model="dlgAddSelected.courseName"
                                  />
                                  <button
                                    type="button"
                                    class="btn btn-danger btn-lg"
                                    @click="handleClrAddSel()"
                                  >
                                    <i class="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.credit") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <label>{{ dlgAddSelected.credit }}</label>
                        </div>
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classTime") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <label v-html="dlgAddSelected.classTime">{{
                            dlgAddSelected.classTime
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.section") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <label>{{ dlgAddSelected.section }}</label>
                        </div>
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <!-- <label>{{ $t("messages.general.section") }}</label> -->
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <label>{{ dlgAddSelected.section }}</label> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.reason") }}
                            <label class="text-danger">*</label>
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <input
                            type="text"
                            class="form-control col mr-2"
                            style="margin-right: 0px !important"
                            v-model="reason"
                            @keyup="handleChangeReason"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-temp btn-lg"
                          @click="handleSearchAdd()"
                        >
                          {{ $t("messages.general.save") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="dialogAddSelected = false"
                        >
                          {{ $t("messages.general.cancel") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogClassReserved"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>edit</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classDetail")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogClassReserved = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t("messages.general.section") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classType") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classTime") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.room") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.receiveAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.registerAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.remainAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.requestAmount") }}
                        </th>
                        <th v-if="!isReserved">
                          {{ $t("messages.general.select") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, index) in classDetail" :key="index">
                      <tr>
                        <td class="text-center">{{ item.secText }}</td>
                        <td class="text-center" v-html="item.CLASSTYPE">
                          {{ item.CLASSTYPE }}
                        </td>
                        <td
                          v-html="item.CLASSTIME"
                          class="text-center"
                          style="white-space: nowrap"
                        >
                          {{ item.CLASSTIME }}
                        </td>
                        <td
                          class="text-center"
                          style="white-space: nowrap"
                          v-html="item.CLASSROOM"
                        >
                          {{ item.CLASSROOM }}
                        </td>
                        <td class="text-center">{{ item.TOTALSEAT }}</td>
                        <td class="text-center">{{ item.TOTALSUMSEAT }}</td>
                        <td class="text-center">
                          {{ item.TOTALSEAT - item.TOTALSUMSEAT }}
                        </td>
                        <td class="text-center">{{ item.ENROLLSEAT }}</td>
                        <td v-if="!isReserved" class="text-center">
                          <v-btn
                            x-small
                            color="rgba(11, 187, 236, 0.9)"
                            :disabled="getDisabledSelectBtn(item)"
                            @click="handleChangeSelect(item)"
                            >select</v-btn
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="9" style="padding: 0 !important">
                          <v-expansion-panels
                            accordion
                            style="height: 100%; border-radius: 0 !important"
                          >
                            <v-expansion-panel>
                              <v-expansion-panel-header>{{
                                $t("messages.general.moreDetail")
                              }}</v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div class="information-block">
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t("messages.general.teachers")
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>
                                            <span
                                              v-for="(itemInst,
                                              indexInst) in item.arrInstructor"
                                              :key="indexInst"
                                            >
                                              {{ itemInst }}
                                              <br />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t("messages.general.reserveFor")
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <v-icon @click="openSubDetail(item)"
                                            >search</v-icon
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t(
                                                "messages.general.examMidTermDate"
                                              )
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>
                                            {{ item.EXAM_MIDTERM_DATE }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t(
                                                "messages.general.examFinalTermDate"
                                              )
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>{{ item.EXAM_FINAL_DATE }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div
                                            style="text-decoration: underline; color: blue"
                                          >
                                            {{ $t("messages.general.remark") }}
                                          </div>
                                        </div>
                                        <div
                                          class="col no-margin-padding"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="light-green accent-3">
                <v-icon color="light-green darken-2">fa-check</v-icon>
                <v-toolbar-title style="color: green;"
                  >&nbsp;{{
                    $t("messages.reqRegister.confirmPopupText")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogConfirmSuccess = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="green accent-1">
                <br />
                <span v-html="successText" style="color: green;">{{
                  successText
                }}</span>
                <br /><br />
                <strong style="color: red; font-weight: bold; font-size: 16px;">
                  {{ $t("messages.reqRegister.confirmRemark") }}
                </strong>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogInfo" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>fa-info</v-icon>
                <v-toolbar-title>&nbsp;{{ dialogInfoTitle }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogInfo = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <br />
                <span
                  v-html="infoText"
                  style="font-size: 16px;font-weight: bold;"
                >
                  {{ infoText }}
                </span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">
                  {{ errorText }}
                </span>
                <br /><br />
                <strong style="color: red; font-weight: bold; font-size: 16px;">
                  {{ $t("messages.reqRegister.confirmRemark") }}
                </strong>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogComfirmAdd" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>fa-check</v-icon>
                <v-toolbar-title
                  >&nbsp;{{
                    $t("messages.reqRegister.confirmPopupText")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogComfirmAdd = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="green accent-1">
                <br />
                <span style="font-size: 16px;font-weight: bold;">
                  {{ dialogComfirmAddMsg }}
                </span>
                <form>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-temp btn-lg"
                          @click="isChange ? changeSection() : addPreEnroll()"
                        >
                          {{ $t("messages.general.ok") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="dialogComfirmAdd = false"
                        >
                          {{ $t("messages.general.cancel") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogComfirmDelete" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>delete</v-icon>
                <v-toolbar-title
                  >&nbsp;{{
                    $t("messages.reqRegister.confirmDelPopupText")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogComfirmDelete = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="green accent-1">
                <br />
                <span v-html="dialogComfirmDeleteMsg">{{
                  dialogComfirmDeleteMsg
                }}</span>
                <form>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-temp btn-lg"
                          @click="deletePreEnroll()"
                        >
                          {{ $t("messages.general.ok") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="dialogComfirmDelete = false"
                        >
                          {{ $t("messages.general.cancel") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogDetail"
            hide-overlay
            scrollable
            max-width="1024px"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>description</v-icon>
                <v-toolbar-title>{{
                  $t("messages.chkOpenClass.reserveClassDetail")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogDetail = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            {{ classItem.ACADYEAR }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            {{ classItem.SEMESTER }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classId") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            {{ classItem.COURSECODE }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.className") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            {{ classItem.COURSENAME }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.section") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            {{ classItem.SECTION2 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <v-tabs>
                  <v-tab>{{ $t("messages.general.student") }}</v-tab>
                  <v-tab>{{ $t("messages.general.studyPlan") }}</v-tab>
                  <v-tab>{{ $t("messages.general.faculty") }}</v-tab>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.identity") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.fullname") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revStudent" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODE2 }}
                            </td>
                            <td class="text-center">
                              {{ item.STUNAME }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studyPlan") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studentCodeRange") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.reservedAmount") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revPlan" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td style="white-space: nowrap">
                              {{ item.DESCRIPTION }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODEFROM }} -
                              {{ item.STUDENTCODETO }}
                            </td>
                            <td class="text-center">{{ item.RESERVESEAT }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.faculty") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studentCodeRange") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.reservedAmount") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revFaculty" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td class="text-center" style="white-space: nowrap">
                              {{ item.FACNAME }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODEFROM }} -
                              {{ item.STUDENTCODETO }}
                            </td>
                            <td class="text-center">{{ item.RESERVESEAT }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogEdit"
            hide-overlay
            scrollable
            max-width="1024px"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>edit</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.edit")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogEdit = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.reason") }}
                            <label class="text-danger">*</label>
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <input
                            type="text"
                            class="form-control col mr-2"
                            style="margin-right: 0px !important"
                            v-model="reasonEdit"
                            @keyup="handleChangeRemark"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-temp btn-lg"
                          @click="handleEdit()"
                        >
                          {{ $t("messages.general.save") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="dialogEdit = false"
                        >
                          {{ $t("messages.general.cancel") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color">
                <v-toolbar-title
                  v-html="selectedEvent.name"
                  style="color: #fff !important"
                ></v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <span>{{ selectedEvent.section }}</span
                ><br />
                <span>{{ selectedEvent.building }}</span
                ><br />
                <span
                  >{{ selectedEvent.starttime }} -
                  {{ selectedEvent.endtime }}</span
                >
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  {{ $t("messages.general.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/th";
import ClassProvider from "@/services/class_provider";
import PreEnrollProvider from "@/services/preEnroll_provider";

import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import ClassType from "@/components/Dropdown/ClassType.vue";
import Level from "@/components/Dropdown/Level.vue";

const classProvider = new ClassProvider();
const preEnrollProvider = new PreEnrollProvider();

export default {
  name: "reqRegister",
  components: {
    Faculty,
    Department,
    ClassType,
    Level
  },
  data() {
    return {
      expPanels: 0,
      readonly: false,
      multiple: false,
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle"
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "GRADEMODE",
            label: this.$t("messages.general.grade"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "CLASSTIME",
            label: this.$t("messages.general.classTime"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          }
        ]
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 }
      ],
      perPage: 100,
      currentPage: 1,
      dialogClassReserved: false,
      dialogSelected: false,
      dialogSearchClass: false,
      dialogDetailAll: false,
      dialogAddSelected: false,
      dialogConfirmSuccess: false,
      structure: true,
      focus: "",
      today: new Date(),
      locale: "th",
      color: "pink",
      intervals: {
        first: 7,
        minutes: 60,
        count: 14,
        height: 30
      },
      shortIntervals: false,
      shortWeekdays: false,
      eventColor: "#0bbbec",
      detail: 0,
      weekDays: [1, 2, 3, 4, 5, 6, 0],
      classListByPlan: [],
      classReservedList: [],
      epp2Selected: -1,
      classReservedSelected: -1,
      classSelectedList: [],
      epp3Selected: -1,
      classDetail: false,
      classSelDetial: false,
      dlgAddSelected: {
        classid: 0,
        courseCode: "",
        courseName: "",
        credit: "",
        grade: "",
        classTime: "",
        section: "",
        classStatus: ""
      },
      dialogComfirmAdd: false,
      dialogComfirmAddMsg: "",
      classidAdd: 0,
      classOldId: 0,
      footerTotal: {
        TOTAL_CLASS: 0,
        TOTAL_CLASS_CONFIRM: 0,
        TOTAL_CREDIT: 0,
        TOTAL_CREDIT_CONFIRM: 0
      },
      prevDateRange: "",
      nextDateRange: "",
      prevDateFirst: new Date(),
      nextDateFirst: new Date(),
      dlgAddSelCourseCode: "",
      dlgAddSelCourseName: "",
      dlgSearchClassSelFaculty: 0,
      dlgSearchClassSelDepartment: 0,
      dlgSearchClassSelClsType: "",
      dlgSearchClassSelLvl: 3,
      examData: [],
      // financeData: [],
      // financeFooterData: {},
      selectClassIdx: 0,
      changeSectionIdx: 0,
      classAllSection: [],
      isReserved: false,
      isChange: false,
      numberFormatOpt: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      errorText: "",
      dialogError: false,
      dialogErrorTitle: "",
      dialogInfoTitle: "",
      selectClass: {
        code: "",
        name: ""
      },
      dialogComfirmDelete: false,
      dialogComfirmDeleteMsg: "",
      deleteGuid: "",
      deleteClass: "",
      dialogInfo: false,
      infoText: "",
      successText: "",
      reason: "",
      reasonEdit: "",
      isShowCaution: false,
      isShowCautionText: false,
      showCautionText: "",
      currentDateRange: {
        firstDate: new Date(),
        lastDate: new Date()
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      dialogDetail: false,
      classItem: {},
      dialogEdit: false,
      editItem: {},
      preEnrollWithInstructor: [],
      preEnrollWithInstructorMsg: ""
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    isLateReq: function() {
      return this.appInfo.data.SCHEDULE_PERIOD == 2;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    },
    currentProgramId: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.PROGRAMID
        : this.studentInfo.data.PROGRAMID;
    },
    currentStudyPlanId: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDYPLANID
        : this.studentInfo.data.STUDYPLANID;
    },
    studentCode: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERCODE_TXT
        : this.studentInfo.data.STUDENTCODE;
    },
    displayName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERNAME
        : `${this.studentInfo.data.PREFIXNAME} ${this.studentInfo.data.STUDENTNAME} ${this.studentInfo.data.STUDENTSURNAME}`;
    }
  },
  async mounted() {
    this.tokenHealthChk();
    this.loadData();
    this.getPrevNextDateRange(this.today);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    async loadData() {
      this.togglePreLoader(true);
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      this.isShowCautionText = "";
      this.locale = this.currentLang;
      const classParamDefault = {
        token: this.token,
        request: {
          studentid: this.currentUserId,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      };
      const clsByPlan = await classProvider.getSemesterPlanByStudentId({
        token: this.token,
        request: {
          studentid: this.currentUserId,
          programid: this.currentProgramId,
          studyplanid: this.currentStudyPlanId,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      });
      if (clsByPlan != undefined && clsByPlan.length > 0) {
        clsByPlan.forEach(d => {
          if (d.COURSENAME != undefined) {
            const tmpName = this.replaceNewLine(d.COURSENAME);
            d.COURSENAME = this.replaceTab(tmpName);
          }
        });
      }
      this.classListByPlan = clsByPlan;
      this.classReservedList = await this.getReserveList();
      this.classSelectedList = await this.getClassSelected();
      const dataPreEnrollTotal = await preEnrollProvider.getPreEnrollTotal(
        classParamDefault
      );
      if (dataPreEnrollTotal != undefined && dataPreEnrollTotal.length > 0) {
        this.footerTotal = dataPreEnrollTotal[0];
      }
      this.getPreEnrollWithInstructor();
      this.togglePreLoader(false);
    },
    async getReserveList() {
      const classParamDefault = {
        token: this.token,
        request: {
          studentid: this.currentUserId,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      };
      const clsReserveTemp = await classProvider.getClassReservePre(
        classParamDefault
      );
      if (clsReserveTemp != undefined && clsReserveTemp.length > 0) {
        clsReserveTemp.forEach(d => {
          if (d.CLASSTIME != undefined) {
            d.CLASSTIME = this.replaceNewLine(d.CLASSTIME);
          }
        });
      }
      return clsReserveTemp;
    },
    async getPreEnrollWithInstructor() {
      if (this.isLateReq) {
        const preEnrollWithInstructorRes = await preEnrollProvider.preEnrollWithInstructor(
          {
            token: this.token,
            request: {
              studentid: this.currentUserId,
              acadyear: this.appInfo.data.CURRENT_ACADYEAR,
              semester: this.appInfo.data.CURRENT_SEMESTER,
              lang: this.currentLang
            }
          }
        );
        if (
          preEnrollWithInstructorRes.data != undefined &&
          preEnrollWithInstructorRes.data.length > 0
        ) {
          preEnrollWithInstructorRes.data.forEach(d => {
            if (d.INSTRUCTORNAME != undefined) {
              d.INSTRUCTORNAME = this.replaceNewLine(d.INSTRUCTORNAME);
            }
          });
        }
        this.preEnrollWithInstructor = preEnrollWithInstructorRes.data;
        this.preEnrollWithInstructorMsg = this.replaceNewLine(
          preEnrollWithInstructorRes.message
        );
        // console.log(
        //   "this.preEnrollWithInstructor",
        //   this.preEnrollWithInstructor
        // );
      }
    },
    async handleClickSelectedEpp2(index) {
      this.epp2Selected = index;
      const selectedClass = this.classReservedList[index];
      this.selectClass = {
        code: selectedClass.COURSECODE,
        name: selectedClass.COURSENAME
      };
      await this.addSearch(selectedClass.CLASSID, false);
    },
    initialSectionData(data) {
      let result = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.secText = "";
        if (element.SECTION2 != undefined) {
          element.secText = element.SECTION2;
        }

        if (element.SECTION_TEXT != undefined) {
          element.secText = element.SECTION_TEXT;
        }

        if (element.CLASSTYPE != undefined) {
          element.CLASSTYPE = this.replaceNewLine(element.CLASSTYPE);
        }
        if (element.CLASSTIME != undefined) {
          element.CLASSTIME = this.replaceNewLine(element.CLASSTIME);
        }
        if (element.CLASSROOM != undefined) {
          element.CLASSROOM = this.replaceNewLine(element.CLASSROOM);
        }

        element.arrInstructor = [];
        if (element.INSTRUCTOR != null) {
          element.arrInstructor = element.INSTRUCTOR.split("|");
        }
        result.push(element);
      }
      return result;
    },
    async openClassReserved(index) {
      this.togglePreLoader(true);
      this.dialogClassReserved = true;
      this.isReserved = true;
      this.classReservedSelected = index;
      const sel = this.classReservedList[index];
      const data = await classProvider.getClassDetail({
        token: this.token,
        request: {
          classid: sel.CLASSID,
          lang: this.currentLang
        }
      });
      this.togglePreLoader(false);
      if (data.length > 0) {
        this.classDetail = this.initialSectionData(data);
      } else {
        this.classDetail = false;
      }
    },
    replaceNewLine(data) {
      return data.toString().replace(/\|/g, "<br />");
    },
    replaceTab(data) {
      return data.toString().replace(/<T>/g, "&emsp;");
    },
    async getClassSelected() {
      const classSelectedListTemp = await preEnrollProvider.getPreEnroll({
        token: this.token,
        request: {
          studentid: this.currentUserId,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      });
      if (
        classSelectedListTemp != undefined &&
        classSelectedListTemp.length > 0
      ) {
        classSelectedListTemp.forEach(d => {
          if (d.CLASSTIME != undefined) {
            d.CLASSTIME = this.replaceNewLine(d.CLASSTIME);
          }
        });
      }
      return classSelectedListTemp;
    },
    initialSelectedData(data) {
      let result = data[0];
      result.arrInstructor = [];
      if (result.INSTRUCTOR != null) {
        result.arrInstructor = result.INSTRUCTOR.split("|");
      }
      if (result.CLASSTYPE != null) {
        result.CLASSTYPE = this.replaceNewLine(result.CLASSTYPE);
      }
      if (result.CLASSTIME != null) {
        result.CLASSTIME = this.replaceNewLine(result.CLASSTIME);
      }
      if (result.CLASSROOM != null) {
        result.CLASSROOM = this.replaceNewLine(result.CLASSROOM);
      }
      return result;
    },
    async openSelected(index) {
      this.togglePreLoader(true);
      this.dialogSelected = true;
      this.epp3Selected = index;
      const sel = this.classSelectedList[index];
      const data = await classProvider.getClassDetail({
        token: this.token,
        request: {
          classid: sel.CLASSID,
          lang: this.currentLang
        }
      });
      this.togglePreLoader(false);
      if (data.length > 0) {
        this.classSelDetial = this.initialSelectedData(data);
      } else {
        this.classSelDetial = false;
      }
    },
    async openDetail(item, index) {
      this.dialogSelected = true;
      this.detail = index;
      const sel = this.bTable.items[index];
      const data = await classProvider.getClassDetail({
        token: this.token,
        request: {
          classid: sel.CLASSID,
          lang: this.currentLang
        }
      });
      if (data.length > 0) {
        this.classSelDetial = this.initialSelectedData(data);
      } else {
        this.classSelDetial = false;
      }
    },
    openAddSelected(index) {
      this.handleClrAddSel();
      this.dialogAddSelected = true;
      this.addSelected = index;
    },
    intervalFormatter(interval) {
      const arrTime = interval.time.split(":");
      const sh = arrTime[0];
      // const eh = parseInt(sh) + 1;
      // const pad = "00";
      if (sh > 20) return "";
      // return `${pad.substring(0, pad.length - sh.toString().length) + sh.toString()}:00 - ${pad.substring(0, pad.length - eh.toString().length) + eh.toString()}:00`;
      return interval.time;
    },
    weekdayFormatter(e) {
      return moment(e.date)
        .locale(this.currentLang)
        .format("dddd");
    },
    dayFormatter(e) {
      const year = moment(e.date)
        .locale(this.currentLang)
        .format("YYYY");
      const month = moment(e.date)
        .locale(this.currentLang)
        .format("M");
      return `${moment(e.date)
        .locale(this.currentLang)
        .format("DD")} ${this.getMonthText(month)} ${this.getYearText(year)}`;
    },
    getEventName(e) {
      return `<div style="white-space: normal;">${e.input.name}<div>`;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    async setToday() {
      this.togglePreLoader(true);
      this.focus = moment(this.today).format("YYYY-MM-DD");
      this.getPrevNextDateRange(this.today);
      await this.getClassTime(this.today);
      this.togglePreLoader(false);
    },
    async setFocusDate(d) {
      const dt = new Date(d);
      this.togglePreLoader(true);
      this.focus = moment(dt).format("YYYY-MM-DD");
      this.getCurrentDateRange(dt);
      this.getPrevNextDateRange(dt);
      this.togglePreLoader(false);
    },
    async prev() {
      this.togglePreLoader(true);
      this.getPrevNextDateRange(this.prevDateFirst);
      await this.getClassTime(
        this.getSundayForPrevRange(this.currentDateRange.firstDate)
      );
      this.togglePreLoader(false);
      this.$refs.calendar.prev();
    },
    async next() {
      this.togglePreLoader(true);
      this.getPrevNextDateRange(this.nextDateFirst);
      await this.getClassTime(
        this.getMondayForNextRange(this.currentDateRange.lastDate)
      );
      this.togglePreLoader(false);
      this.$refs.calendar.next();
    },
    getYearText(year) {
      return this.currentLang == "th" ? `${parseInt(year) + 543}` : `${year}`;
    },
    getMonthText(month) {
      let result = "";
      switch (month) {
        case "1":
          result = this.currentLang == "th" ? "มกราคม" : "January";
          break;
        case "2":
          result = this.currentLang == "th" ? "กุมภาพันธ์" : "February";
          break;
        case "3":
          result = this.currentLang == "th" ? "มีนาคม" : "March";
          break;
        case "4":
          result = this.currentLang == "th" ? "เมษายน" : "April";
          break;
        case "5":
          result = this.currentLang == "th" ? "พฤษภาคม" : "May";
          break;
        case "6":
          result = this.currentLang == "th" ? "มิถุนายน" : "June";
          break;
        case "7":
          result = this.currentLang == "th" ? "กรกฎาคม" : "July";
          break;
        case "8":
          result = this.currentLang == "th" ? "สิงหาคม" : "August";
          break;
        case "9":
          result = this.currentLang == "th" ? "กันยายน" : "September";
          break;
        case "10":
          result = this.currentLang == "th" ? "ตุลาคม" : "October";
          break;
        case "11":
          result = this.currentLang == "th" ? "พฤศจิกายน" : "November";
          break;
        case "12":
          result = this.currentLang == "th" ? "ธันวาคม" : "December";
          break;
      }
      return result;
    },
    getSundayForPrevRange(d) {
      return d.setDate(d.getDate() - 1);
    },
    getMondayForNextRange(d) {
      return d.setDate(d.getDate() + 1);
    },
    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    getCurrentDateRange(d) {
      this.currentDateRange.firstDate = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate())
      );
      this.currentDateRange.lastDate = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 6)
      );
      return {
        first: `${moment(this.currentDateRange.firstDate).format(
          "MM/DD/YYYY"
        )}`,
        last: `${moment(this.currentDateRange.lastDate).format("MM/DD/YYYY")}`
      };
    },
    getPrevNextDateRange(d) {
      d = new Date(d);
      const prevDateRangeFirstD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() - 7)
      );
      this.prevDateFirst = prevDateRangeFirstD;
      const prevDateRangeLastD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() - 1)
      );
      const nextDateRangeFirstD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 7)
      );
      this.nextDateFirst = nextDateRangeFirstD;
      const nextDateRangeLastD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 13)
      );
      this.prevDateRange = `${moment(prevDateRangeFirstD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        prevDateRangeFirstD.getFullYear()
      )} - ${moment(prevDateRangeLastD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        prevDateRangeLastD.getFullYear()
      )}`;
      this.nextDateRange = `${moment(nextDateRangeFirstD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        nextDateRangeFirstD.getFullYear()
      )} - ${moment(nextDateRangeLastD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        nextDateRangeLastD.getFullYear()
      )}`;
    },
    onDlgSearchClassSelFacultyChanged(event) {
      this.dlgSearchClassSelFaculty = event.target.value;
    },
    onDlgSearchClassSelDepartmentChanged(event) {
      this.dlgSearchClassSelDepartment = event.target.value;
    },
    onDlgSearchClassSelClsTypeChanged(event) {
      this.dlgSearchClassSelClsType = event.target.value;
    },
    onDlgSearchClassSelLvlChanged(event) {
      this.dlgSearchClassSelLvl = event.target.value;
    },
    async handleBlurSearchCls() {
      let result = true;
      const val = this.dlgAddSelected.courseCode;
      if (val != "") {
        this.togglePreLoader(true);
        const data = await classProvider.searchPreOpenCourse({
          token: this.token,
          request: {
            studentid: this.currentUserId,
            acadyear: this.appInfo.data.CURRENT_ACADYEAR,
            semester: this.appInfo.data.CURRENT_SEMESTER,
            lang: this.currentLang,
            facultyid: 0,
            departmentid: 0,
            levelid: 3,
            coursecode: val,
            structure: "N"
          }
        });
        if (data.length == 1) {
          this.handleSelectClass(data[0], 0);
        } else {
          result = false;
        }
        this.togglePreLoader(false);
        return result;
      }
    },
    async handleOpenSearchCls() {
      let result = false;
      const isHaveVal = this.dlgAddSelected.courseCode != "";
      if (isHaveVal) {
        result = await this.handleBlurSearchCls();
      }
      if (!result) {
        this.dialogSearchClass = true;
        this.handleClearSearchCls(this.dlgAddSelected.courseCode);
        this.handleClrAddSel();
        if (isHaveVal) {
          await this.handleSearchCls();
        }
      }
    },
    async handleSearchCls() {
      this.togglePreLoader(true);
      const tempRequest = {
        studentid: this.currentUserId,
        acadyear: this.appInfo.data.CURRENT_ACADYEAR,
        semester: this.appInfo.data.CURRENT_SEMESTER,
        lang: this.currentLang,
        facultyid:
          this.dlgSearchClassSelFaculty == 0
            ? ""
            : this.dlgSearchClassSelFaculty,
        departmentid:
          this.dlgSearchClassSelDepartment == 0
            ? ""
            : this.dlgSearchClassSelDepartment,
        coursegroup:
          this.dlgSearchClassSelClsType === "NONE"
            ? ""
            : this.dlgSearchClassSelClsType,
        levelid: this.dlgSearchClassSelLvl,
        structure: this.structure ? "Y" : "N"
      };
      if (this.dlgAddSelCourseCode != "") {
        tempRequest["coursecode"] = this.dlgAddSelCourseCode;
      }
      if (this.dlgAddSelCourseName != "") {
        tempRequest["coursename"] = this.dlgAddSelCourseName;
      }
      var classTimeReq = {
        token: this.token,
        request: tempRequest
      };
      const data = await classProvider.searchPreOpenCourse(classTimeReq);
      this.bTable.items = [];
      if (data.length > 0) {
        let idx = 0;
        data.map(d => {
          if (d.CLASSTIME != undefined) {
            d.CLASSTIME = this.replaceNewLine(d.CLASSTIME);
          }
          d.rowNumber = idx + 1;
          this.bTable.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    handleClearSearchCls(code = "") {
      this.dlgAddSelCourseCode = code;
      this.dlgAddSelCourseName = "";
      this.dlgSearchClassSelFaculty = 0;
      this.dlgSearchClassSelDepartment = 0;
      this.dlgSearchClassSelClsType = "";
      this.dlgSearchClassSelLvl = 3;
      this.reason = "";
      this.bTable.items = [];
    },
    handleSelectClass(item, index) {
      this.selectClassIdx = index;
      this.dialogSearchClass = false;
      this.dlgAddSelected.classid = item.CLASSID;
      this.dlgAddSelected.courseCode = item.COURSECODE;
      this.dlgAddSelected.courseName = item.COURSENAME;
      this.dlgAddSelected.credit = item.COURSEUNIT;
      this.dlgAddSelected.grade = item.COURSETYPE;
      this.dlgAddSelected.classTime = item.CLASSTIME;
      this.dlgAddSelected.section = item.SECTION_TEXT;
      this.dlgAddSelected.classStatus = item.COURSESTATUS;
      this.bTable.items = [];
    },
    handleClrAddSel() {
      this.dlgAddSelected.classid = 0;
      this.dlgAddSelected.courseCode = "";
      this.dlgAddSelected.courseName = "";
      this.dlgAddSelected.credit = "";
      this.dlgAddSelected.grade = "";
      this.dlgAddSelected.classTime = "";
      this.dlgAddSelected.section = "";
      this.dlgAddSelected.classStatus = "";
      this.reason = "";
    },
    async handleSearchAdd() {
      if (this.reason == "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${this.$t("messages.reqRegister.reasonRequried")}`;
        return;
      }
      this.selectClass = {
        code: this.dlgAddSelected.courseCode,
        name: this.dlgAddSelected.courseName
      };
      this.togglePreLoader(true);
      await this.addSearch(this.dlgAddSelected.classid, false);
      this.togglePreLoader(false);
      this.dialogAddSelected = false;
    },
    async addSearch(classid, isChange) {
      this.togglePreLoader(true);
      this.isChange = isChange;
      this.classidAdd = classid;
      const resIsClassReserve = await classProvider.isClassReserve({
        token: this.token,
        request: {
          studentid: this.currentUserId,
          classid: classid,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      });
      if (
        resIsClassReserve.code != undefined &&
        resIsClassReserve.code == 403
      ) {
        this.dialogComfirmAdd = true;
        this.dialogComfirmAddMsg = resIsClassReserve.data[0].MESSAGE;
      } else {
        if (isChange) {
          await this.changeSection();
        } else {
          await this.addPreEnroll();
        }
      }
      this.togglePreLoader(false);
    },
    async addPreEnroll() {
      this.dialogComfirmAdd = false;
      this.togglePreLoader(true);
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      this.isShowCautionText = "";
      const payload = {
        studentid: this.currentUserId,
        acadyear: this.appInfo.data.CURRENT_ACADYEAR,
        semester: this.appInfo.data.CURRENT_SEMESTER,
        classid: this.classidAdd,
        remark: this.reason == "" ? "วิชาที่ได้สำรองสิทธิ์" : this.reason,
        create_userid: this.userId,
        lang: this.currentLang
      };
      let res = await preEnrollProvider.postPreEnroll(this.token, payload);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogInfo = true;
        this.infoText = `${res.message.split(" ").join("<br/>")}`;
        this.reason = "";
        this.classSelectedList = await this.getClassSelected();
        this.classReservedList = await this.getReserveList();
        const dataEnrollTotal = await preEnrollProvider.getPreEnrollTotal({
          token: this.token,
          request: {
            studentid: this.currentUserId,
            acadyear: this.appInfo.data.CURRENT_ACADYEAR,
            semester: this.appInfo.data.CURRENT_SEMESTER,
            lang: this.currentLang
          }
        });
        if (dataEnrollTotal != undefined && dataEnrollTotal.length > 0) {
          this.footerTotal = dataEnrollTotal[0];
        }
        this.getPreEnrollWithInstructor();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>${this.$t(
          "messages.general.classId"
        )}: ${this.selectClass.code}<br/>${this.$t(
          "messages.general.className"
        )}:  ${this.selectClass.name}`;
      }
    },
    async openDialogDetailAll() {
      this.togglePreLoader(true);
      const payload = {
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          lang: this.currentLang
        }
      };
      await this.getClassTime(this.today, true);
      this.examData = await classProvider.getPreExamTime(payload);
      // this.financeData = await classProvider.getFinance(payload);
      // this.financeFooterData.total = 0;
      // this.financeFooterData.totalBack = 0;
      // if (this.financeData != undefined) {
      //   for (let i = 0; i < this.financeData.length; i++) {
      //     this.financeFooterData.total += this.financeData[i].BALANCE;
      //     this.financeFooterData.totalBack +=
      //       this.financeData.AMOUNT - this.financeData[i].BALANCE;
      //   }
      // }
      this.dialogDetailAll = true;
      this.togglePreLoader(false);
    },
    numberFormat(num) {
      return Number(num).toLocaleString(this.currentLang, this.numberFormatOpt);
    },
    async openDialogChangeSection(index) {
      this.togglePreLoader(true);
      this.dialogClassReserved = true;
      this.isReserved = false;
      this.changeSectionIdx = index;
      const sel = this.classSelectedList[index];
      this.classOldId = sel.CLASSID;
      const data = await classProvider.getCourseAllByClassId({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          classid: sel.CLASSID,
          lang: this.currentLang
        }
      });
      this.togglePreLoader(false);
      if (data.length > 0) {
        this.classDetail = this.initialSectionData(data);
      } else {
        this.classDetail = [];
      }
    },
    async handleChangeSelect(item) {
      this.selectClass = {
        code: item.COURSECODE,
        name: item.COURSENAME
      };
      await this.addSearch(item.CLASSID, true);
    },
    async changeSection() {
      this.togglePreLoader(true);
      const payload = {
        studentid: parseInt(this.currentUserId.toString()),
        acadyear: this.appInfo.data.CURRENT_ACADYEAR,
        semester: this.appInfo.data.CURRENT_SEMESTER,
        classid_new: this.classidAdd,
        classid_old: this.classOldId,
        create_userid: this.userId.toString(),
        lang: this.currentLang
      };
      let res = await preEnrollProvider.changeSection(this.token, payload);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogComfirmAdd = false;
        this.dialogClassReserved = false;
        this.classOldId = 0;
        this.isChange = false;
        this.classSelectedList = await this.getClassSelected();
        this.getPreEnrollWithInstructor();
      }
    },
    handleDelete(item) {
      this.dialogComfirmDeleteMsg = `<b>${this.$t(
        "messages.general.classCode"
      )}:</b><br/>${item.COURSENAME}`;
      this.deleteGuid = item.PRE_REG_DTL_GUID;
      this.deleteClass = item.COURSENAME;
      this.dialogComfirmDelete = true;
    },
    async deletePreEnroll() {
      this.dialogComfirmDelete = false;
      this.togglePreLoader(true);
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      this.isShowCautionText = "";
      const payload = {
        pre_reg_dtl_guid: this.deleteGuid,
        create_userid: this.userId,
        lang: this.currentLang
      };
      let res = await preEnrollProvider.deletePreEnroll(this.token, payload);
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.dialogInfo = true;
        this.infoText = `${res.message.split(" ").join("<br/>")}`;
        this.deleteGuid = "";
        this.classSelectedList = await this.getClassSelected();
        this.classReservedList = await this.getReserveList();
        const dataEnrollTotal = await preEnrollProvider.getPreEnrollTotal({
          token: this.token,
          request: {
            studentid: this.currentUserId,
            acadyear: this.appInfo.data.CURRENT_ACADYEAR,
            semester: this.appInfo.data.CURRENT_SEMESTER,
            lang: this.currentLang
          }
        });
        if (dataEnrollTotal != undefined && dataEnrollTotal.length > 0) {
          this.footerTotal = dataEnrollTotal[0];
        }
        this.getPreEnrollWithInstructor();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>${this.$t(
          "messages.general.classCode"
        )}: ${this.deleteClass}`;
      }
    },
    async handleConfirm() {
      this.togglePreLoader(true);
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      this.isShowCautionText = "";
      const payload = {
        studentid: this.currentUserId,
        acadyear: this.appInfo.data.CURRENT_ACADYEAR,
        semester: this.appInfo.data.CURRENT_SEMESTER,
        schedule_period: this.appInfo.data.SCHEDULE_PERIOD,
        user_type: this.appInfo.data.USER_TYPE,
        method: "X",
        submit_userid: this.userId,
        lang: this.currentLang
      };
      let res = await preEnrollProvider.confirmPreEnroll(this.token, payload);
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.classSelectedList = await this.getClassSelected();
        this.classReservedList = await this.getReserveList();
        const dataEnrollTotal = await preEnrollProvider.getPreEnrollTotal({
          token: this.token,
          request: {
            studentid: this.currentUserId,
            acadyear: this.appInfo.data.CURRENT_ACADYEAR,
            semester: this.appInfo.data.CURRENT_SEMESTER,
            lang: this.currentLang
          }
        });
        if (dataEnrollTotal != undefined && dataEnrollTotal.length > 0) {
          this.footerTotal = dataEnrollTotal[0];
        }
        this.getPreEnrollWithInstructor();
      } else {
        // this.dialogErrorTitle = this.$t(
        //   "messages.reqRegister.confirmPopupText"
        // );
        this.dialogError = true;
        // this.isShowCaution = this.appInfo.data.ISSHOW_ADVISORWARNING == "Y";
        this.isShowCautionText = true;
        const { data, message } = res;
        let errMsg = "";
        if (
          data.length == 0 ||
          (data.length > 0 &&
            data[0].ERR_DESC !== undefined &&
            data[0].ERR_DESC == null)
        ) {
          errMsg = `${message}<br/>`;
        } else {
          this.dialogErrorTitle = message;
          data.forEach(e => {
            errMsg += `${e.ERR_DESC}<br/>`;
          });
        }
        this.errorText = `${errMsg}`;
        this.showCautionText = errMsg;
        window.scrollTo(0, document.body.scrollHeight);
      }
    },
    getDateFromWeekDay(weekday) {
      const d = new Date(this.currentDateRange.firstDate);
      let dayToAdd = 0;
      switch (weekday) {
        case "Monday":
          dayToAdd = 0;
          break;
        case "Tuesday":
          dayToAdd = 1;
          break;
        case "Wednesday":
          dayToAdd = 2;
          break;
        case "Thursday":
          dayToAdd = 3;
          break;
        case "Friday":
          dayToAdd = 4;
          break;
        case "Saturday":
          dayToAdd = 5;
          break;
        case "Sunday":
          dayToAdd = 6;
          break;
      }
      return d.setDate(d.getDate() + dayToAdd);
    },
    initTimetable(data) {
      const d = this.getDateFromWeekDay(data.WEEKDAY);
      return {
        name: `${data.COURSECODE}-${
          data.COURSENAME ? data.COURSENAME : data.COURSENAMEENG
        }`,
        section: data.SECTION_TEXT,
        building: data.BUILDINGNAME,
        start: `${moment(d).format("YYYY-MM-DD")} ${data.TIMEFROM}`,
        end: `${moment(d).format("YYYY-MM-DD")} ${data.TIMETO}`,
        starttime: data.TIMEFROM,
        endtime: data.TIMETO,
        color: this.eventColor
      };
    },
    async getClassTime(d, ignoreDate = false) {
      const curretDateRangeTxt = ignoreDate ? {} : this.getCurrentDateRange(d);
      const classTime = await classProvider.getPreClassTime({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          firstdate: ignoreDate ? "11/11/1111" : curretDateRangeTxt.first,
          lastdate: ignoreDate ? "11/11/1111" : curretDateRangeTxt.last,
          lang: this.currentLang
        }
      });
      const tmpEvent = [];
      let isFirst = true;
      classTime.forEach(c => {
        if (isFirst && ignoreDate) {
          isFirst = false;
          this.setFocusDate(moment(c.OPEN_DATE).toDate());
        }
        tmpEvent.push(this.initTimetable(c));
      });
      if (tmpEvent.length == 0 && ignoreDate) {
        this.setToday();
      }
      this.events = tmpEvent;
    },
    getDisabledSelectBtn(item) {
      if (
        item !== undefined &&
        item.ISSHOW_SELECTBUTTON !== undefined &&
        item.ISSHOW_SELECTBUTTON == "N"
      ) {
        return true;
      }
      return false;
    },
    async openSubDetail(classItem) {
      this.togglePreLoader(true);
      this.dialogDetail = true;
      const param = {
        token: this.token,
        request: {
          classid: classItem.CLASSID,
          lang: this.currentLang
        }
      };
      this.classItem = classItem;
      this.revStudent = await classProvider.getClassReserveByStudent(param);
      this.revPlan = await classProvider.getClassReserveByStudyplan(param);
      this.revFaculty = await classProvider.getClassReserveByFaculty(param);
      this.togglePreLoader(false);
    },
    openDialogEdit(item) {
      this.editItem = item;
      this.reasonEdit = item.REASON;
      this.dialogEdit = true;
    },
    async handleEdit() {
      if (this.reasonEdit == "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${this.$t("messages.reqRegister.reasonRequried")}`;
        return;
      }
      this.togglePreLoader(true);
      const payload = {
        pre_reg_dtl_guid: this.editItem.PRE_REG_DTL_GUID,
        remark: this.reasonEdit,
        create_userid: this.userId,
        lang: this.currentLang
      };
      let res = await preEnrollProvider.putPreEnroll(this.token, payload);
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.dialogEdit = false;
        this.dialogInfo = true;
        this.infoText = `${res.message.split(" ").join("<br/>")}`;
        this.reason = "";
        this.classSelectedList = await this.getClassSelected();
        this.classReservedList = await this.getReserveList();
        const dataEnrollTotal = await preEnrollProvider.getPreEnrollTotal({
          token: this.token,
          request: {
            studentid: this.currentUserId,
            acadyear: this.appInfo.data.CURRENT_ACADYEAR,
            semester: this.appInfo.data.CURRENT_SEMESTER,
            lang: this.currentLang
          }
        });
        if (dataEnrollTotal != undefined && dataEnrollTotal.length > 0) {
          this.footerTotal = dataEnrollTotal[0];
        }
        this.getPreEnrollWithInstructor();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>${this.$t(
          "messages.general.classCode"
        )}: ${this.editItem.COURSENAME}`;
      }
    },
    handleChangeRemark(e) {
      if (e.target.value.length > 300) {
        this.reasonEdit = e.target.value.substring(0, 300);
      }
    },
    handleChangeReason(e) {
      if (e.target.value.length > 300) {
        this.reason = e.target.value.substring(0, 300);
      }
    }
  },
  watch: {
    currentLang() {
      this.loadData();
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle"
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "GRADEMODE",
          label: this.$t("messages.general.grade"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "CLASSTIME",
          label: this.$t("messages.general.classTime"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        }
      ];
    }
  }
};
</script>

<style scoped>
.v-input label {
  color: red !important;
}
.eep2Sel,
.eep3Sel {
  background-color: rgba(11, 187, 236, 0.9) !important;
}
.text-nowarp {
  white-space: nowrap;
}
.table-responsive table thead {
  /* background-image: linear-gradient(
    180deg,
    rgba(11, 187, 236, 0.9),
    rgba(164, 70, 143, 0.9)
  ); */
  background-color: rgba(164, 70, 143);
}
</style>
